export default () => ({
    images: {},
    colors: {},
    teamsId: [],
    tagging: null,
    shortcuts: {},
    filteredCount: null,
    notTagged: false,
    allSelected: false,
    selectedImages: [],
    selectedIndexes: [],
    notSelectedImages: [],
    lastSelectedIndex: null,
    allDeleted: false,
    idsToIgnore: [],

    init() {
        document.body.addEventListener('keyup', this.shortcut.bind(this));
    },

    getImageCode(image) {
        if (!image.name) {
            return 'loading...';
        }

        const imageCode = image.name?.split('_').pop().split('.')[0];

        if (imageCode && image.event_code) {
            return `${image.event_code}_${imageCode}`;
        }

        return imageCode ?? 'loading...';
    },

    shortcut(event) {
        if (
            this.getSelectedImagesQuantity() &&
            _.keys(this.shortcuts).includes(event.key)
        ) {
            this.setTag(this.shortcuts[event.key]);
        }
    },

    setTag({label, value}) {
        this.$dispatch('photo-view:update-tag', {
            turnTo: this.getTeams({label, value})
        });

        const selectedImages = this.getSelectedImages();

        if (!this.allSelected) {
            _.each(selectedImages, (imageId) => {
                const imageKey = _.findIndex(this.images, {id: imageId});
                const imageData = _.get(this.images, imageKey, {});

                if (!_.has(imageData, 'teams')) {
                    imageData.teams = [];
                }

                imageData.teams = this.getTeams(
                    {label, value},
                    _.get(imageData, 'teams', [])
                );

                this.images[imageKey] = imageData;
            });

            this.refreshVirtualScroll();
        }

        this.$dispatch('picture::tagged', [
            value,
            this.selectedImages,
            this.allSelected,
            this.notTagged,
            this.teamsId
        ]);

        if (!(value instanceof Object) || !_.isEmpty(value)) {
            this.allSelected = false;
            this.selectedImages = [];

            this.refreshVirtualScroll();
        }
    },

    getTeams({label, value}, teams = []) {
        if (value instanceof Object) {
            if (_.isEmpty(value)) {
                return value;
            }

            return _.uniqBy([...teams, ..._.values(value)], 'id');
        }

        return _.uniqBy([...teams, {name: label, id: value}], 'id');
    },

    selectedPhotosLabel() {
        let total = 0;

        if (this.images.length) {
            const selectedImagesQuantity = this.getSelectedImagesQuantity();

            total = `${selectedImagesQuantity < this.imagesCount ? selectedImagesQuantity : 'All'}`;
        }

        return total + ' ' + 'photo' + `${total <= 1 ? '' : 's'}` + ' ' + 'selected';
    },

    isSelected(imageId, entireObject = false) {
        if (entireObject) {
            return this.allSelected || this.selectedImages.some(image => image.id == imageId);
        }

        return this.allSelected ?
            !this.selectedImages.includes(imageId) :
            this.selectedImages.includes(imageId);
    },

    getSelectedImagesQuantity() {
        return this.getSelectedImages().length;
    },

    getSelectedImages() {
        return this.allSelected ?
            _.filter(
                _.mapValues(this.images, 'id'),
                (imageId) => !this.selectedImages.includes(imageId)
            ) :
            this.selectedImages;
    },

    handlePreview({detail: {high_res}}) {
        const link = document.createElement('a');
        link.href = high_res;
        link.target = '_blank';
        link.click();
    },

    handleCheck({detail: {selectedIds, shiftKey, data, selected}}) {
        let shifted = false;

        if (!_.has(data, 'id')) {
            return;
        }

        if (this.allSelected) {
            selectedIds = this.selectedImages;

            if (selected) {
                selectedIds = _.without(selectedIds, data.id);
            } else {
                selectedIds.push(data.id);
            }
        }

        if (shiftKey && this.lastSelectedIndex !== null) {
            const firstImage = this.images[this.lastSelectedIndex];
            const selectedImages = _.uniq([...this.selectedImages, ...selectedIds]);

            selectedIds = this.selectWithShift(data, selectedIds, !selectedImages.includes(firstImage.id));
            shifted = true;
        }

        this.lastSelectedIndex = _.findIndex(this.images, {'id': data.id});
        this.selectedImages = _.values(selectedIds);

        if (shifted) {
            this.refreshVirtualScroll();
        }
    },

    selectItemsFromPhotoView({detail: {selectedIds, selectedIndexes}}) {
        this.selectedImages = selectedIds;
        this.selectedIndexes = selectedIndexes ?? [];
    },

    handleSelected({detail: {selectedIds, shiftKey, data}}) {
        let shifted = false;

        if (!_.has(data, 'id')) {
            return;
        }

        this.allDeleted = false;

        if (shiftKey && this.lastSelectedIndex !== null) {
            const firstImage = this.images[this.lastSelectedIndex];
            selectedIds = this.selectWithShift(data, selectedIds, !selectedIds.includes(firstImage.id));
            shifted = true;
        }

        if ((this.idsToIgnore?.length || this.allSelected)) {
            if (selectedIds.includes(data.id)) {
                this.idsToIgnore = _.without(this.idsToIgnore, data.id);
            } else {
                this.idsToIgnore.push(data.id);
            }
        }

        this.notSelectedImages = [];
        this.lastSelectedIndex = _.findIndex(this.images, {'id': data.id});
        this.selectedImages = this.images?.filter((image) => {
            if (!selectedIds.includes(image.id)) {
                this.allSelected = false;
            }

            if (selectedIds.includes(image.id)) {
                return true;
            }

            this.notSelectedImages.push(image);
            return false;
        });

        if (shifted) {
            this.refreshVirtualScroll({}, 'quality-control::refresh');
        }
    },

    selectWithShift(data, selectedIds, remove = false) {
        const currentIndex = _.findIndex(this.images, {'id': data.id});
        const lastSelectedIndex = this.lastSelectedIndex;

        let images = _.slice(this.images, this.lastSelectedIndex ?? 0, currentIndex);

        if (lastSelectedIndex > currentIndex) {
            images = _.slice(this.images, currentIndex, lastSelectedIndex);
        }

        const imageIds = _.map(images, 'id');
        let newSelectedIds = _.uniq(_.union(selectedIds, imageIds));

        if (remove) {
            newSelectedIds = _.filter(newSelectedIds, (id) => !imageIds.includes(id));
        }

        return newSelectedIds;
    },

    refreshVirtualScroll(data = {}, eventName = 'event-images::refresh') {
        data.selected = this.selectedImages;
        this.$dispatch(eventName, data);
    },

    countSelectedImages(imageCount) {
        const hasFilter = this.notTagged || this.teamsId.length > 0;

        if (hasFilter && this.filteredCount !== null) {
            imageCount = this.filteredCount;
        }

        const selectedImagesCount = this.selectedImages.length;

        if (selectedImagesCount > imageCount) {
            imageCount = selectedImagesCount;
        }

        if (this.allSelected) {
            return this.selectedImages.length
                ? imageCount - this.selectedImages.length
                : 'All';
        }

        const selectedQuantity = this.getSelectedImagesQuantity();

        return selectedQuantity < imageCount
            ? selectedQuantity
            : 'All';
    },

    deselectAll(eventName = 'event-images::refresh') {
        this.selectedImages = [];
        this.selectedIndexes = [];
        this.allSelected = false;

        this.refreshVirtualScroll({
            selected: this.selectedImages
        }, eventName);

        this.$dispatch('photo-view::toggle-all', {
            allSelected: false
        });
    },

    selectAll(eventName = 'event-images::refresh') {
        this.selectedImages = [];
        this.selectedIndexes = [];
        this.allSelected = true;

        this.refreshVirtualScroll({
            selected: this.selectedImages
        }, eventName);

        this.$dispatch('photo-view::toggle-all', {
            allSelected: true
        });
    },

    setFilters(notTagged, teamsId, filteredCount = null) {
        this.notTagged = notTagged;
        this.teamsId = teamsId;
        this.filteredCount = filteredCount;
    },

    setColors(colors = null) {
        if (colors?.length) {
            this.colors = colors;
        }

        this.$dispatch('event-images::set', {colors: this.colors});
    },

    handlePinClick(selectedImages, pinnedImageId, el) {
        const imageId = selectedImages[0];
        const dispatch = () => this.$dispatch('pin-photo', { imageId });

        if (pinnedImageId && imageId !== pinnedImageId) {
            window.$wireui.confirmDialog({
                title: el.dataset.confirmTitle,
                description: el.dataset.confirmDescription,
                icon: 'question',
                accept: {
                    label: el.dataset.confirmAccept,
                    execute: dispatch,
                },
                reject: { label: el.dataset.confirmReject },
            });
        } else {
            dispatch();
        }
    },

    close() {
        this.shortcuts = [];
        this.allSelected = false;
        this.selectedImages = [];
        this.selectedIndexes = [];

        this.$nextTick(() => this.$wire.call('closeWithoutRender'));
    }
});
